<app-main-navbar></app-main-navbar>
<!-- Page Title -->
<div class="page-title-area" [ngStyle]="{ 'background-image': 'url(' + blogImage + ')' }">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <h1 class="text-start">{{ blogTitle }}</h1>
        <h2 *ngIf="blogSubtitle.length <= 120" class="text-start">{{ blogSubtitle }}</h2>
        <p *ngIf="blogSubtitle.length > 120" class="text-start" style="color: var(--blackColor)">{{ blogSubtitle }}</p>
      </div>
    </div>
  </div>
  <div class="shape2 rotateme"><img src="assets/img/shapes/shape2.svg" alt="shape" /></div>
  <div class="shape3"><img src="assets/img/shapes/shape3.svg" alt="shape" /></div>
  <div class="shape4"><img src="assets/img/shapes/shape4.svg" alt="shape" /></div>
  <div class="shape5"><img src="assets/img/shapes/shape5.png" alt="shape" /></div>
  <div class="shape6 rotateme"><img src="assets/img/shapes/shape4.svg" alt="shape" /></div>
  <div class="shape7"><img src="assets/img/shapes/shape4.svg" alt="shape" /></div>
  <div class="shape8 rotateme"><img src="assets/img/shapes/shape2.svg" alt="shape" /></div>
</div>

<div class="blog-content">
  <div class="blog-area ptb-80">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-12"><router-outlet></router-outlet></div>
        <div class="col-lg-4 col-md-12">
          <aside class="widget-area" id="secondary">
            <div class="widget widget_search">
              <form class="search-form" (ngSubmit)="onSubmitSearch()">
                <label>
                  <span class="screen-reader-text" i18n="@@searchForBlogContent">Search for:</span>
                  <input
                    i18n-placeholder="@@searchBlogContent"
                    type="search"
                    class="search-field"
                    placeholder="Search..."
                    [(ngModel)]="search"
                  />
                </label>
                <button type="submit"><i-feather name="search"></i-feather></button>
              </form>
            </div>
            <div class="widget widget_startp_posts_thumb">
              <h3 class="widget-title" i18n="@@latestArticlesBlogContent">Latest Articles</h3>
              <article class="item" *ngFor="let article of latestContent; index as i">
                <app-latest-item [blogItem]="article"></app-latest-item>
              </article>
            </div>
            <div class="widget widget_tag_cloud">
              <h3 class="widget-title">Tags</h3>
              <div class="tagcloud">
                <ng-container *ngFor="let tag of tags; index as i">
                  <a href="javascript:void(0)" (click)="searchByTag(tag.name)" class="text-uppercase"
                    >{{ tag.name }} <span class="tag-link-count"> ({{ tag.count }})</span></a
                  >
                </ng-container>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer">
  <app-footer [showGoogle]="false"></app-footer>
</div>
